var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.68 0.742188H2.32002C1.81097 0.742717 1.32292 0.945172 0.962964 1.30513C0.603009 1.66508 0.400554 2.15313 0.400024 2.66219V14.1822C0.400554 14.6912 0.603009 15.1793 0.962964 15.5392C1.32292 15.8992 1.81097 16.1017 2.32002 16.1022H17.68C18.1891 16.1017 18.6771 15.8992 19.0371 15.5392C19.397 15.1793 19.5995 14.6912 19.6 14.1822V2.66219C19.5995 2.15313 19.397 1.66508 19.0371 1.30513C18.6771 0.945172 18.1891 0.742717 17.68 0.742188ZM17.68 2.66219V3.15219L10 9.12719L2.32002 3.15419V2.66219H17.68ZM2.32002 14.1822V5.58219L9.41102 11.0972C9.57912 11.2293 9.78673 11.3011 10.0005 11.3011C10.2143 11.3011 10.4219 11.2293 10.59 11.0972L17.681 5.58219V14.1822H2.32002Z",
    fill: "#00A2B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.81fd64f785176398079757d5498a28c2.svg";
export { ForwardRef as ReactComponent };